import type { ReactElement } from 'react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import ErrorMessage from 'atom-components/error-message-from-hook-form';
import Textarea from 'atom-components/form-fields-for-hook-form/textarea';
import Label from 'atom-components/label';
import styles from './comment.module.scss';

type Props = {
  canEditMark: boolean;
};

export default function Comment({ canEditMark }: Props): ReactElement {
  const { control, formState, setValue } = useFormContext();

  // ID "commentSection" used to link to outer div
  const commentSectionId = 'commentSection';
  const textareaName = 'comment';
  return (
    <div id={commentSectionId} className={styles.commentWithLabel}>
      <div>
        <Label htmlFor={textareaName}>Comment</Label>
      </div>
      <div className={styles.comment}>
        <Textarea
          id={textareaName}
          control={control}
          name={textareaName}
          disabled={!canEditMark}
          onChange={(): void => setValue('hasAskedToFlagForAttention', false)}
        />
        {formState.errors.comment && (
          <ErrorMessage errors={formState.errors} name="comment" className={styles.errorMessage} />
        )}
      </div>
    </div>
  );
}
